import axios from 'axios';
import { environment } from '../../../environments/environment';
import { PhoneNumber } from '../interfaces/phone-number.interface';
import { IvrConfiguration } from '../interfaces/ivr-configuration.interface';
import { TtsSynthesizeRequest, TtsSynthesizeResponse } from '../interfaces/tts.interface';

class IvrConfigService {
  private axios = axios.create({
    baseURL: environment.activate.baseURL,
  });

  async getPhoneNumbers(organizationId: string): Promise<PhoneNumber[]> {
    return this.axios
      .get(`/organizations/${organizationId}/phone-numbers`)
      .then((res) => res.data);
  }

  async getIvrConfiguration(
    organizationId: string,
    phoneNumberId: string
  ): Promise<IvrConfiguration> {
    return this.axios
      .get(`/organizations/${organizationId}/ivr-configuration/${phoneNumberId}`)
      .then((res) => res.data);
  }

  async updateIvrConfiguration(
    organizationId: string,
    config: IvrConfiguration
  ): Promise<IvrConfiguration> {
    return this.axios
      .put(`/organizations/${organizationId}/ivr-configuration`, config)
      .then((res) => res.data);
  }

  async synthesizeTts(
    organizationId: string,
    request: TtsSynthesizeRequest
  ): Promise<TtsSynthesizeResponse> {
    return this.axios
      .post(`/organizations/${organizationId}/synthesize-tts`, request)
      .then((res) => res.data);
  }
}

export default new IvrConfigService();
